
import { useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useSession } from "@/hooks/useSession";

export function useProgressInitializer(resourceId?: string, fileId?: string) {
  const { session } = useSession();

  const initializeTracking = useCallback(async () => {
    if (!resourceId || !fileId || !session?.user?.id) return;

    try {
      // Check if a record already exists
      const { data: existingProgress, error: checkError } = await supabase
        .from('training_progress')
        .select('id')
        .eq('resource_id', resourceId)
        .eq('file_id', fileId)
        .eq('user_id', session.user.id)
        .maybeSingle();
        
      if (checkError) {
        console.error('Error checking existing progress:', checkError);
        return;
      }
      
      // If no record exists, create one with completed = false
      if (!existingProgress) {
        console.log(`Initializing tracking for file ${fileId} in resource ${resourceId}`);
        
        const { error: insertError } = await supabase
          .from('training_progress')
          .insert({
            resource_id: resourceId,
            file_id: fileId,
            user_id: session.user.id,
            completed: false,
            updated_at: new Date().toISOString()
          });
          
        if (insertError) {
          console.error('Error initializing training progress:', insertError);
        }
      }
    } catch (err) {
      console.error('Error in initializeTracking:', err);
    }
  }, [resourceId, fileId, session?.user?.id]);

  return {
    initializeTracking
  };
}
